import { useQuery } from "@apollo/client";
import {
  DocumentsByUserOrganizationIdDocument,
  DocumentsByUserOrganizationIdQuery,
} from "../../../../../../__generated__/graphql";

export default function useDocumentsByUserOrganizationId(
  userOrganizationId?: string | null,
  onCompleted?: (data: DocumentsByUserOrganizationIdQuery) => void
) {
  const { data, loading, error, refetch } = useQuery(
    DocumentsByUserOrganizationIdDocument,
    {
      variables: { userOrganizationId: userOrganizationId ?? "" },
      skip: !userOrganizationId,
      onCompleted,
    }
  );

  return {
    data,
    loading,
    error,
    refetch,
  };
}
